import { useQuery } from '@tanstack/react-query';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';

/**
 * #62 — DMARC-Berichte (Betreiber-Sicht, alle Kunden). Nur lesend: die Berichte
 * kommen ausschließlich aus dem Postmaster-Postfach. M2M-Auth wie alle
 * /v1/admin/*-Endpoints.
 *
 * Overview = Aggregat je Domain der letzten N Tage (domain, berichte,
 * nachrichten, bestanden, gescheitert, zuletzt). Reports = Roh-Zeilen aus
 * `dmarc_reports` (org_name, report_id, range_*, messages_*, received_at).
 */
const OVERVIEW_FIXTURE = {
  items: [
    { domain: 'kunde-a.de', berichte: 12, nachrichten: 4200, bestanden: 4180, gescheitert: 20, zuletzt: new Date().toISOString() },
    { domain: 'kunde-b.de', berichte: 5, nachrichten: 900, bestanden: 700, gescheitert: 200, zuletzt: new Date().toISOString() },
  ],
};

const REPORTS_FIXTURE = {
  items: [
    { id: 101, domain: 'kunde-a.de', org_name: 'google.com', report_id: '1234567890', range_begin: new Date(Date.now() - 864e5).toISOString(), range_end: new Date().toISOString(), messages_total: 350, messages_passed: 349, messages_failed: 1, received_at: new Date().toISOString() },
    { id: 100, domain: 'kunde-b.de', org_name: 'enterprise.protection.outlook.com', report_id: 'abc987', range_begin: new Date(Date.now() - 864e5).toISOString(), range_end: new Date().toISOString(), messages_total: 120, messages_passed: 90, messages_failed: 30, received_at: new Date().toISOString() },
  ],
};

export function useDmarcOverview() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['dmarc-overview', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return OVERVIEW_FIXTURE; }
      return nexusFetch('/v1/admin/dmarc/overview');
    },
    refetchInterval: 60_000,
  });
}

export function useDmarcReports() {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['dmarc-reports', fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return REPORTS_FIXTURE; }
      return nexusFetch('/v1/admin/dmarc/reports?limit=100');
    },
    refetchInterval: 60_000,
  });
}
